/**
 * Wait for an element matching `selector` to appear in the DOM. Mirrors the
 * onboarding module's `waitForElementById` but resolves by CSS selector so it
 * can target `data-agent-target` attributes.
 *
 * @returns true if found before the timeout, false otherwise.
 */
export function waitForSelector(
  selector: string,
  timeout = 2500,
  interval = 50,
): Promise<boolean> {
  if (typeof document === "undefined") {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    const startTime = performance.now()

    const check = () => {
      if (document.querySelector(selector)) {
        resolve(true)
        return
      }
      if (performance.now() - startTime >= timeout) {
        resolve(false)
        return
      }
      setTimeout(check, interval)
    }

    check()
  })
}
